// extracted by css-extract-rspack-plugin
export default {"labelColorIndicator":"ListLabelFilter-module__labelColorIndicator__CFA9mXr","labelFilterButton":"ListLabelFilter-module__labelFilterButton__mHzYMeX"};